"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeatureFlagOverrides = void 0;
const STORAGE_KEY = 'ampcore:feature-flag-overrides';
/**
 * Local development utility for overriding LaunchDarkly feature flags
 * via localStorage. Only intended for non-production environments.
 *
 * Usage from browser console:
 *   FEATURE_FLAG_OVERRIDES.set('release-evolved-facets', true)
 *   FEATURE_FLAG_OVERRIDES.set('amp-isElementVisible', false)
 *   FEATURE_FLAG_OVERRIDES.remove('release-evolved-facets')
 *   FEATURE_FLAG_OVERRIDES.list()
 *   FEATURE_FLAG_OVERRIDES.clear()
 *
 * NOTE: Page reload is required after setting overrides for them to take effect.
 */
class FeatureFlagOverrides {
    static get(flagKey) {
        if (!this.isEnabled())
            return undefined;
        const overrides = this.getAll();
        return flagKey in overrides ? overrides[flagKey] : undefined;
    }
    static set(flagKey, value) {
        const overrides = this.getAll();
        overrides[flagKey] = value;
        this.save(overrides);
    }
    static remove(flagKey) {
        const overrides = this.getAll();
        delete overrides[flagKey];
        this.save(overrides);
    }
    static list() {
        return this.getAll();
    }
    static clear() {
        try {
            localStorage.removeItem(STORAGE_KEY);
        }
        catch {
            // localStorage unavailable
        }
    }
    static isEnabled() {
        if (globalThis.window === undefined)
            return false;
        return true;
    }
    static getAll() {
        try {
            const raw = localStorage.getItem(STORAGE_KEY);
            if (!raw)
                return {};
            return JSON.parse(raw);
        }
        catch {
            return {};
        }
    }
    static save(overrides) {
        try {
            localStorage.setItem(STORAGE_KEY, JSON.stringify(overrides));
        }
        catch {
            // localStorage unavailable
        }
    }
}
exports.FeatureFlagOverrides = FeatureFlagOverrides;
